import {
  SecondaryColorTwo, maxMobile, maxWidth, primaryFont, primaryHeadingColor, retina, wLight, wMedium,
} from 'Utils/utilsStyle';
import React from 'react';
import styled from 'styled-components';
import DocumentHub from 'Pages/document/DocumentHub';
import HeadingWithToolTip from 'Components/common/components/HeadingWithToolTip';
import { FormQuestion } from 'Types/CompaniesTypes';

const Wrapper = styled.div`
.heading-div {
display: flex;
align-items: center;
justify-content: space-between;
margin-bottom: 6px;
  .main-upload-heading{
    font-family: ${primaryFont};
    font-weight: ${wMedium};
    font-size: 18px;
    line-height: 20px;
    color: ${SecondaryColorTwo};
    margin-bottom: 0px;
  }
  .global-tooltip-element {
    position: relative;
    display: inline-flex;
    .section-detail-tip {
      .ant-tooltip {
        left: unset !important;
        right: 25px !important;
        top: 10px !important;
      }
    }
  }
}
  .uploadaing-para-text{
    color: ${primaryHeadingColor};
    font-family: ${primaryFont};
    font-weight: ${wLight};
    font-size: 12px;
    line-height: 16px;
    margin-bottom: 16px;
  }
  .uploadBtn{
    color: #fff;
    background: #122669;
    padding: 20px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: ${primaryFont};
    border-radius: 7px;
    margin-bottom: 10px;
    font-size: 18px;
    height: 60px;
    cursor: pointer;
    @media all and (max-width: ${maxWidth}), ${retina}{
      padding: 15px;
    }
    @media all and (max-width: ${maxMobile}) {
      height: 45px;
    }
    .upload-alignment{
      height: 14px;
      width: 13px;
      margin-bottom: 5px;
      margin-left: 10px;
    }
  }
`;

type Props = {
  question: FormQuestion
};

const UploadDocument = function UploadDocument(props: Props) {
  const { question } = props;
  const { statement, tooltip, example } = question;
  return (
    <Wrapper className="upload-document-btn-account-plan">
      <div className="heading-div">
        <h3 className="main-upload-heading">Upload new documents</h3>
        <HeadingWithToolTip
          heightIcon="19px"
          widthIcon="16px"
          heightIconSm="20px"
          widthIconSm="13px"
          customWidth="280px"
          toolTipText={tooltip}
          exampleText={example}
          toolPlacement="bottomRight"
          midTabletFlag
          htmlFlag
        />
      </div>
      <p className="uploadaing-para-text">
        {statement}
      </p>
      <DocumentHub inSmartDrawer />
    </Wrapper>
  );
};

export default UploadDocument;
